import {lazy} from './lazy.js';
import {PADDING} from 'components/effects/plane/constants.js';

export const slice = (p, i, j) => {
  return (...args) => {
    let coords = args[0];
    let _p = lazy(p, ...args);
    let _i = lazy(i, ...args);
    let _j = !j ? _i + 1 : lazy(j, ...args);
    
    let ret = {
    };
    let keys = Object.keys(_p);

    for (let k=_i; k < _j; k++) {
      let _k = k % keys.length;
      ret[keys[_k]] = _p[keys[_k]];    
    }
    
    return ret;
  };
};

export const proportion = (p, ...params) => {
  return (...args) => {
    let _params = params.map(
      pa => lazy(pa, ...args));
    let _proportion = lazy(p, ...args);
    let ret = { 
      ... args[0]
    };
    
    for (let part of _params) {
      let first = _params[0];
      if (first === part) continue;
      let p_keys = Object.keys(part);
      let f_keys = Object.keys(first);
      p_keys.forEach((key, i) => {
          ret[key] = {
            ... first[f_keys[i % f_keys.length]]
          };
          ret[key].x = _proportion * (ret[key].x - PADDING) + PADDING;
          ret[key].y = _proportion * (ret[key].y - PADDING) + PADDING;
        });
    }
    return ret;
  };
};
